The time period for which the certification is effective.

This will be `null` if the expiration date is unknown or not provided.
